const BronzeMedalIc = () => {
	return (
		<svg
			width={38}
			height={38}
			viewBox="0 0 38 38"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M25.2278 24.5957V34.8346C25.2278 35.679 24.2778 36.1013 23.6444 35.5735L20.0556 32.6179C20.0556 32.6179 19.95 32.6179 19.95 32.5124C19.6333 32.3013 19.3167 32.1957 19 32.1957C18.5778 32.1957 18.2611 32.3013 17.9444 32.6179L14.3556 35.679C13.7222 36.2068 12.7722 35.7846 12.7722 34.9401V24.7013H25.2278V24.5957Z"
				fill="#F45170"
			/>
			<path
				d="M25.2278 24.5957V34.8346C25.2278 35.679 24.2778 36.1013 23.6444 35.5735L20.0556 32.6179C20.0556 32.6179 19.95 32.6179 19.95 32.5124C19.6333 32.3013 19.3167 32.1957 19 32.1957V24.5957H25.2278Z"
				fill="#E93565"
			/>
			<path
				d="M25.2278 27.0234V28.6068C24.2778 28.8179 23.1167 28.5012 22.2722 28.7123C21.2167 29.029 20.1611 30.1901 19 30.1901C17.8389 30.1901 16.7833 29.029 15.7278 28.7123C14.7778 28.5012 13.6167 28.8179 12.7722 28.6068V27.0234H25.2278Z"
				fill="#CC104A"
			/>
			<path
				d="M31.1388 19.0003C30.8221 20.1614 31.3499 21.5336 30.8221 22.5892C30.1888 23.6447 28.711 23.8559 27.8666 24.7003C27.0221 25.5447 26.811 27.0225 25.7555 27.6559C24.8055 28.1836 23.3277 27.6559 22.1666 27.9725C21.111 28.2892 20.0555 29.4503 18.8943 29.4503C17.7332 29.4503 16.6777 28.2892 15.6221 27.9725C14.461 27.6559 13.0888 28.1836 12.0332 27.6559C11.0832 27.1281 10.7666 25.5447 9.92212 24.7003C9.07767 23.8559 7.5999 23.6447 6.96656 22.5892C6.43879 21.6392 6.96656 20.1614 6.6499 19.0003C6.33323 17.9447 5.17212 16.8892 5.17212 15.7281C5.17212 14.567 6.33323 13.5114 6.6499 12.4559C6.96656 11.2947 6.43879 9.92253 6.96656 8.86697C7.49434 7.91697 9.07767 7.6003 9.92212 6.75586C10.7666 5.91142 10.9777 4.43364 12.0332 3.8003C12.9832 3.27253 14.461 3.8003 15.6221 3.48364C16.6777 3.16697 17.7332 2.00586 18.8943 2.00586C20.0555 2.00586 21.111 3.16697 22.1666 3.48364C23.3277 3.8003 24.6999 3.27253 25.7555 3.8003C26.7055 4.32808 27.0221 5.91142 27.8666 6.75586C28.711 7.6003 30.1888 7.81141 30.8221 8.86697C31.3499 9.81697 30.8221 11.2947 31.1388 12.4559C31.4555 13.5114 32.6166 14.567 32.6166 15.7281C32.6166 16.8892 31.4555 17.9447 31.1388 19.0003Z"
				fill="#BC9000"
			/>
			<g opacity="0.4">
				<path
					d="M29.2388 15.7272C29.2388 21.3216 24.6999 25.9661 18.9999 25.9661C13.4054 25.9661 8.76099 21.4272 8.76099 15.7272C8.76099 10.1327 13.2999 5.48828 18.9999 5.48828C24.5943 5.48828 29.2388 10.1327 29.2388 15.7272Z"
					fill="white"
				/>
			</g>
			<path
				d="M28.1831 15.7283C28.1831 20.7949 24.0664 24.9116 18.9997 24.9116C13.9331 24.9116 9.81641 20.7949 9.81641 15.7283C9.81641 10.6616 13.9331 6.54492 18.9997 6.54492C24.0664 6.54492 28.1831 10.6616 28.1831 15.7283Z"
				fill="#9C7907"
			/>
			<path
				d="M28.1832 16.3615C27.8665 11.5059 23.8554 7.70593 18.9999 7.70593C14.1443 7.70593 10.1332 11.5059 9.81653 16.3615C9.49986 10.8726 13.9332 6.43926 18.9999 6.54482C24.1721 6.65037 28.4999 10.767 28.1832 16.3615Z"
				fill="#705601"
			/>
			<path
				d="M14.3554 8.9735C14.0388 8.9735 13.8277 9.18461 13.6166 9.39572C13.7221 9.50128 14.7777 10.3457 14.6721 10.4513C14.5666 10.5568 13.511 9.81795 13.4054 9.71239C13.2999 9.9235 13.1943 10.2402 13.2999 10.4513C13.6166 13.0902 13.1943 13.1957 12.6666 10.5568C12.561 10.2402 12.4554 10.0291 12.2443 9.81795C12.1388 9.9235 11.2943 10.9791 11.1888 10.8735C11.0832 10.7679 11.8221 9.71239 11.9277 9.60683C11.7166 9.50128 11.3999 9.50128 11.1888 9.50128C8.44433 9.71239 8.33878 9.39572 11.0832 8.86795C11.3999 8.76239 11.611 8.65683 11.8221 8.44572C11.8221 8.44572 11.8221 8.44572 11.7166 8.34017C10.2388 7.17906 10.4499 7.0735 11.9277 8.0235H12.0332C12.1388 7.81239 12.2443 7.49572 12.1388 7.28461C11.8221 4.54017 12.2443 4.54017 12.7721 7.17906C12.7721 7.49572 12.9832 7.70683 13.1943 7.91795C13.1943 7.91795 13.1943 7.91795 13.2999 7.81239C14.461 6.33461 14.5666 6.54572 13.6166 8.0235V8.12906C13.7221 8.34017 14.0388 8.44572 14.2499 8.44572C16.9943 8.12906 16.9943 8.44572 14.3554 8.9735Z"
				fill="white"
			/>
			<g opacity="0.5">
				<path
					d="M14.3555 31.773C14.3555 33.2508 14.2499 33.3564 14.0388 33.3564C13.9333 33.3564 13.7222 33.2508 13.7222 31.773C13.7222 30.2953 13.8277 29.873 14.0388 29.873C14.2499 29.873 14.3555 30.2953 14.3555 31.773Z"
					fill="white"
				/>
			</g>
			<g filter="url(#filter0_d_7201_5735)">
				<path
					d="M15.8719 14.392C15.9035 13.4974 16.1806 12.8127 16.7031 12.3377C17.2256 11.8547 17.9539 11.6133 18.8881 11.6133C19.4977 11.6133 20.0162 11.7202 20.4437 11.9339C20.8791 12.1397 21.2077 12.4247 21.4294 12.7889C21.651 13.1452 21.7619 13.5489 21.7619 14.0002C21.7619 14.5385 21.6312 14.9699 21.37 15.2945C21.1087 15.6112 20.8119 15.8249 20.4794 15.9358V15.9833C21.4373 16.3395 21.9162 17.0204 21.9162 18.0258C21.9162 18.5245 21.8014 18.9639 21.5719 19.3439C21.3423 19.7239 21.0098 20.0208 20.5744 20.2345C20.1389 20.4483 19.6204 20.5552 19.0187 20.5552C18.0291 20.5552 17.2454 20.3177 16.6675 19.8427C16.0975 19.3597 15.8006 18.6235 15.7769 17.6339H18.045C18.0291 17.9506 18.0964 18.196 18.2469 18.3702C18.3973 18.5443 18.6229 18.6314 18.9237 18.6314C19.1533 18.6314 19.3314 18.5602 19.4581 18.4177C19.5927 18.2752 19.66 18.0852 19.66 17.8477C19.66 17.5468 19.561 17.3252 19.3631 17.1827C19.1731 17.0402 18.8604 16.9689 18.425 16.9689H18.0094V15.0808H18.4131C18.7139 15.0887 18.9673 15.0412 19.1731 14.9383C19.3869 14.8274 19.4937 14.6097 19.4937 14.2852C19.4937 14.0397 19.4344 13.8577 19.3156 13.7389C19.1969 13.6122 19.0346 13.5489 18.8287 13.5489C18.5991 13.5489 18.4289 13.632 18.3181 13.7983C18.2152 13.9566 18.1558 14.1545 18.14 14.392H15.8719Z"
					fill="white"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_7201_5735"
					x="15.7769"
					y="11.6133"
					width="6.6394"
					height="9.44141"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx="0.5" dy="0.5" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.439216 0 0 0 0 0.337255 0 0 0 0 0.00392157 0 0 0 1 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_7201_5735"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_7201_5735"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default BronzeMedalIc;
